import { render, staticRenderFns } from "./RegistroImeiGPS.vue?vue&type=template&id=2b9f4902&scoped=true"
import script from "./RegistroImeiGPS.vue?vue&type=script&lang=js"
export * from "./RegistroImeiGPS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9f4902",
  null
  
)

export default component.exports